<template>
    <div>
        <AppNavbar />
        <PagesHero :breadcrumbData="{
            title: 'البرامج التعليمية',
            subtitle: {
                first_text: 'الرئيسية',
                first_href: '/',
                second_text: 'البرامج التعليمية'
            }
        }" />
        <div class="container">
            <div class="row">
                <div class="col-lg-4 col-12" v-for="(item, index) in eduPrograms" :key="index">
                    <QuranProgramCard :item="item" />

                </div>
            </div>
        </div>
        <AppFooter />
    </div>
</template>

<script>
import AppNavbar from '@/components/AppNavbar.vue';
import AppFooter from '@/components/AppFooter.vue';
import PagesHero from '@/components/PagesHero.vue';
import Home from "../api/home";
import QuranProgramCard from "../components/QuranPrograms/QuranProgramCard.vue"


export default {
    async created() {
        let programs = await new Home().QuranPrograms({ per_page: 9, with: ['students'] });
        this.eduPrograms = programs.data;
    },
    components: {
        AppFooter, AppNavbar, PagesHero,QuranProgramCard
    },
    data() {
        return {
            eduPrograms: [],
        }
    }
}
</script>

<style scoped>
.row {
    margin-top: 40px;
}
</style>